/**
 * Functional Roles.
 *
 * @format
 */

export const functionalRoles = [
  { name: 'Administrative Assistant', value: 'Administrative Assistant' },
  { name: 'Chief/Dept Administrator', value: 'Chief/Dept Administrator' },
  { name: 'Distributor', value: 'Distributor' },
  { name: 'Dosimetrist', value: 'Dosimetrist' },
  { name: 'Educator', value: 'Educator' },
  { name: 'Engineer/Bio-Med', value: 'Engineer/Bio-Med' },
  {
    name: 'Executive Management (CXO/Owner/VP)',
    value: 'Executive Management (CXO/Owner/VP)',
  },
  { name: 'Facility Management', value: 'Facility Management' },
  { name: 'IT - Management', value: 'IT - Management' },
  { name: 'IT - Technician', value: 'IT - Technician' },
  { name: 'Legal', value: 'Legal' },
  { name: 'Marketing', value: 'Marketing' },
  { name: 'Nurse', value: 'Nurse' },
  { name: 'Nurse - Manager', value: 'Nurse - Manager' },
  { name: 'Other', value: 'Other' },
  { name: 'Pharmacist', value: 'Pharmacist' },
  { name: 'Pharmacist - Chief', value: 'Pharmacist - Chief' },
  { name: 'Physician', value: 'Physician' },
  { name: 'Physicist', value: 'Physicist' },
  { name: 'Project Manager', value: 'Project Manager' },
  { name: 'Purchasing', value: 'Purchasing' },
  { name: 'Research', value: 'Research' },
  { name: 'Student', value: 'Student' },
  {
    name: 'Therapist/Technician/Technologist/Operator',
    value: 'Therapist/Technician/Technologist/Operator',
  },
  { name: 'Therapist - Chief', value: 'Therapist - Chief' },
  { name: 'Varian Employee', value: 'Varian Employee' },
  { name: 'Vendor/3rd Party', value: 'Vendor/3rd Party' },
  { name: 'Veterinarian', value: 'Veterinarian' },
  { name: 'Veterinary Staff', value: 'Veterinary Staff' },
];
